import { m } from '$lib/paraglide/messages';

import type { PageLoadEvent } from './$types';

import DiscountCodesPage from './DiscountCodesPage.svelte';

export const discountCodesLoad = async ({ parent }: PageLoadEvent) => {
	const { store } = await parent();
	return {
		component: DiscountCodesPage,
		title: m['discount_codes.title']({ storeName: store.name }),
	};
};
